/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectStatusApiResponse } from '../models/ConnectStatusApiResponse';
import type { DashboardLinkApiResponse } from '../models/DashboardLinkApiResponse';
import type { OnboardApiResponse } from '../models/OnboardApiResponse';
import type { OnboardDto } from '../models/OnboardDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppStripeConnectService {
    /**
     * Start or resume Stripe Connect onboarding
     * @param requestBody
     * @returns OnboardApiResponse Onboarding URL generated
     * @throws ApiError
     */
    public static stripeConnectControllerOnboardV1(
        requestBody: OnboardDto,
    ): CancelablePromise<OnboardApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/stripe-connect/onboard',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Stripe Connect account status
     * @returns ConnectStatusApiResponse Connect status fetched
     * @throws ApiError
     */
    public static stripeConnectControllerGetStatusV1(): CancelablePromise<ConnectStatusApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/stripe-connect/status',
        });
    }
    /**
     * Get Stripe Express Dashboard link
     * @returns DashboardLinkApiResponse Dashboard link generated
     * @throws ApiError
     */
    public static stripeConnectControllerGetDashboardLinkV1(): CancelablePromise<DashboardLinkApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/stripe-connect/dashboard-link',
        });
    }
}
